import React from 'react'
import Camera from '../../images/icons/camera.svg'
import CloseIcon from '../../images/icons/close_icon.svg'


const MobCamera = props => {
    const OpenCamera = (input_component) => {
        document.getElementById(input_component).click()
    }
    const OpenGallery = (input_component) => {
        document.getElementById(input_component).click()
    }

    return (
        <div className='hidden md:invisible  w-full bg-blue-800 fixed h-40 absolute bottom-0 text-center opacity-100 -ml-2' id={props.main_id}>
          <input className='hidden' type="file" accept='image/jpeg,image/jpg,image/png,application/pdf' id={props.input_component}  onChange ={()=>props.onchange(props.input_component)} />
            <div className='w-full px-3 block '>
                <p className='font-basic font-roboto font-medium text-grey-920 mt-3'>{props.caption}<span className=' mt-4 text-grey-200'>
                    <img className='opacity-25 h-3 float-right' src={CloseIcon} alt='close' /></span></p>
                <ul className='w-full mt-3 text-left'>
                    <li className='flex w-11/12 mt-5 cursor-pointer'>
                        <img className='mr-5' src={Camera} />
                        <p className='font-basic font-roboto font-normal text-grey-920' > <span onClick={() => OpenCamera(props.input_component)}>Camera</span></p>
                    </li>
                    <li className='flex w-11/12 mt-5 cursor-pointer' onClick={() => OpenGallery(props.input_component)}>
                        <img className='mr-5' src={Camera} />
                        <p className='font-basic font-roboto font-normal text-grey-920'> Gallery</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}
export default MobCamera